import React from "react";
import Box from "@mui/material/Box";

const GlobalBanner: React.FC = () => {
    return (
        <Box
            sx={{
                width: "100%",
                border: "1px solid #ddd",
                overflow: "hidden",
                lineHeight: 0,
                // position: "sticky",
                top: 0,
                zIndex: (theme) => theme.zIndex.appBar + 1,
                bgcolor: "background.paper",
            }}
        >
            <Box
                component="img"
                src="/brim-banner.jpg"
                alt="BRIM banner"
                // Banner display settings
                sx={{
                    width: "100%",
                    height: { xs: 230, md: 350 },
                    objectFit: "cover",
                    objectPosition: "top center",
                    display: "block",
                }}
            />
        </Box>
    );
};

export default GlobalBanner;
